import { useState, useRef, useCallback } from "react";

export function useDraggable() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragged, setDragged] = useState(false);
  const posRef = useRef(position);
  posRef.current = position;

  const onMouseDown = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    setDragged(true);
    const startX = e.clientX - posRef.current.x;
    const startY = e.clientY - posRef.current.y;

    const onMouseMove = (ev: MouseEvent) => {
      setPosition({
        x: ev.clientX - startX,
        y: ev.clientY - startY,
      });
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  }, []);

  // 닫기 시 호출 → 닫기 애니메이션 복원
  const prepareClose = useCallback(() => {
    setDragged(false);
    setPosition({ x: 0, y: 0 });
  }, []);

  return { position, onMouseDown, dragged, prepareClose };
}
